module.exports = __webpack_public_path__ + "static/mendix-1f3102a0a61eb25f6896d674e583c93a.png";